import React from 'react';
import {connect} from 'react-redux';
import {selectCardById} from 'state/card/cardSelectors';
import PropTypes from 'prop-types';

const indexAtPath = (urn, card) => {
  if (card.urn === urn) return 0;
  const index = card.drillPathURNs.indexOf(urn);
  return index > -1 ? index + 1 : null;
};

// See https://wikidev.domo.com/confluence/pages/viewpage.action?title=Technical+Overview&spaceKey=devwiki
// for an explanation of why this conversion exists.
// Per Spencer Neese, it catches "Year" filters and also "Week" grains when the company setting for week is set to
// display the first day of the week instead of week number.
const mapDateDataType = filter => {
  return {
    ...filter,
    dataType:
      (filter.dateGrainFilter || filter.filterType === 'CALENDAR') &&
      (filter.operand === 'IN' || filter.operand === 'NOT_IN')
        ? 'string'
        : filter.dataType,
  };
};

class CardDrillManager extends React.Component {
  state = {
    previousCardId: null,
    drillFilters: [],
  };

  static getDerivedStateFromProps = ({cardId}, {previousCardId}) =>
    cardId === previousCardId
      ? null
      : {drillFilters: [], previousCardId: cardId};

  handleDrill = (urn, filters) => {
    const modifiedFilters = (filters || []).map(mapDateDataType);

    const {card, onDrillStarted, onDrillFinished} = this.props;
    const {drillFilters} = this.state;

    onDrillStarted(filters);
    const index = indexAtPath(urn, card);
    const isEndOfDrill = index === card.drillPathURNs.length;
    if (!isEndOfDrill || card.allowTableDrill) {
      const next = [...drillFilters];
      next.splice(index, drillFilters.length - index, modifiedFilters);
      this.setState(
        {
          drillFilters: next,
        },
        () => onDrillFinished(index)
      );
    }
  };

  handlePopDrill = () => {
    const {drillFilters} = this.state;
    const {onPopDrillFinished} = this.props;
    const next = drillFilters.slice(0, -1);
    this.setState(
      {
        drillFilters: next,
      },
      () => onPopDrillFinished()
    );
  };

  render() {
    const {children} = this.props;
    const {drillFilters} = this.state;

    return children({
      drillFilters,
      handleDrill: this.handleDrill,
      handlePopDrill: this.handlePopDrill,
    });
  }

  static propTypes = {
    onDrillStarted: PropTypes.func.isRequired,
    onDrillFinished: PropTypes.func.isRequired,
    onPopDrillFinished: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
    cardId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onDrillStarted: () => {},
    onDrillFinished: () => {},
    onPopDrillFinished: () => {},
  };
}

export default connect((state, {cardId}) => ({
  card: selectCardById(state, cardId),
}))(CardDrillManager);
